export function normalizeAdminPath(pathname: string): string {
  const path = pathname.split('?')[0]?.trim() || '/';
  return path.startsWith('/') ? path : `/${path}`;
}

export function isStandalonePublicAdminRoute(pathname: string): boolean {
  const path = normalizeAdminPath(pathname);

  return (
    path === '/auth/callback' ||
    path.startsWith('/auth/callback/') ||
    path === '/admin/logout' ||
    path.startsWith('/admin/logout/')
  );
}

export function shouldShowAdminShell(pathname: string, hasToken: boolean): boolean {
  if (isStandalonePublicAdminRoute(pathname)) {
    return false;
  }

  const path = normalizeAdminPath(pathname);

  if (path === '/' || path === '/admin/login' || path.startsWith('/admin/login/')) {
    return false;
  }

  return hasToken;
}

export function shouldShowAuthRedirectPreloader(pathname: string, showShell: boolean): boolean {
  if (showShell) {
    return false;
  }

  return !isStandalonePublicAdminRoute(pathname);
}
